module.exports = __webpack_public_path__ + "img/lighthouse-rafiki.89113991.svg";